import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import authService from 'services/authService';
import Swal from 'sweetalert2';
import "views/signIn/SignIn.css";

export const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [validToken, setValidToken] = useState(true);

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });

    const showError = (message) => {
        Toast.fire({
            icon: 'error',
            title: message
        });
    };

    const showSuccess = (message) => {
        Toast.fire({
            icon: 'success',
            title: message
        });
    };

    useEffect(() => {
        if (!token) {
            setValidToken(false);
            showError('Token de recuperación no válido o expirado');
        }
    }, [token]);

    // ---------------- VALIDACIONES ----------------

    const validateForm = () => {
        const newErrors = {};

        if (!formData.newPassword) {
            newErrors.newPassword = 'La contraseña es requerida';
        } else if (formData.newPassword.length < 6) {
            newErrors.newPassword = 'Mínimo 6 caracteres';
        } else if (!/\d/.test(formData.newPassword) || !/[a-zA-Z]/.test(formData.newPassword)) {
            newErrors.newPassword = 'Debe incluir letras y números';
        }

        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'Confirma tu contraseña';
        } else if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Las contraseñas no coinciden';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            showError('Corrige los errores del formulario');
            return false;
        }

        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
            // 🔹 Loading elegante
            Swal.fire({
                title: 'Actualizando contraseña...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const result = await authService.resetPassword({
                token: token,
                newPassword: formData.newPassword
            });

            Swal.close();

            if (result.error) {
                showError(result.data || 'El token puede haber expirado.');
                setLoading(false);
                return;
            }

            showSuccess('Contraseña actualizada correctamente');

            setTimeout(() => {
                navigate('/sign-in');
            }, 2000);

        } catch (err) {
            Swal.close();
            showError('Error de conexión. Intenta nuevamente.');
            setLoading(false);
        }
    };


    if (!validToken) {
        return (
            <div className="login-page">
                <div className="login-container">
                    <div className="login-logo">
                        <div className="logo-login" onClick={() => navigate("/")}>
                            <img
                                src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
                                height="46"
                                alt="María Bonita Logo"
                            />
                        </div>
                    </div>

                    <h2 className="login-title">Enlace Inválido</h2>

                    <div className="register-link">
                        <p>
                            <Link to="/forgot-password">Solicitar nuevo enlace</Link>
                        </p>
                        <p>
                            <Link to="/sign-in">Volver al inicio de sesión</Link>
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <div className="back-to-landing-container">
                <button className="back-to-landing" onClick={() => navigate('/sign-in')}>
                    ← Volver al Login
                </button>
            </div>

            <div className="login-container">
                <div className="login-logo">
                    <div className="logo-login" onClick={() => navigate("/")}>
                        <img
                            src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
                            height="46"
                            alt="María Bonita Logo"
                        />
                    </div>
                </div>

                <h2 className="login-title">Restablecer Contraseña</h2>
                <p className="login-subtitle">
                    Ingresa tu nueva contraseña
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Nueva Contraseña</label>
                        <input
                            type="password"
                            name="newPassword"
                            className={`form-input ${errors.newPassword ? 'input-error' : ''}`}
                            placeholder="••••••••"
                            value={formData.newPassword}
                            onChange={handleChange}
                            disabled={loading}
                            autoComplete="new-password"
                        />
                        {errors.newPassword && (
                            <span className="error-message">{errors.newPassword}</span>
                        )}
                        <small className="form-hint">
                            Mínimo 6 caracteres, debe incluir letras y números
                        </small>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Confirmar Nueva Contraseña</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            className={`form-input ${errors.confirmPassword ? 'input-error' : ''}`}
                            placeholder="••••••••"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            disabled={loading}
                            autoComplete="new-password"
                        />
                        {errors.confirmPassword && (
                            <span className="error-message">{errors.confirmPassword}</span>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-full"
                        disabled={loading}
                    >
                        {loading ? 'Actualizando...' : 'Restablecer Contraseña'}
                    </button>

                    <div className="register-link">
                        <p>
                            <Link to="/sign-in">Volver al inicio de sesión</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};
